import { autoserializeAs, autoserializeAsArray } from 'dcerialize';
import { RestItemList } from './rest-item';

/**
 * Power BI configuration
 */
export class ReportConfig {
  /**
   * Report Name
   */
  @autoserializeAs(() => String) name?: string;

  /**
   * Report ID
   */
  @autoserializeAs(() => String) reportId?: string;

  /**
   * Access Token
   */
  @autoserializeAs(() => String) accessToken?: string;

  /**
   * Embed URL
   */
  @autoserializeAs(() => String) embedUrl?: string;

  /**
   * Dataset ID to use when rendering the Power BI report
   */
  @autoserializeAs(() => String) datasetId?: string;

  constructor(reportName?: string, reportId?: string, accessToken?: string, embedUrl?: string) {
    this.name = reportName;
    this.reportId = reportId;
    this.accessToken = accessToken;
    this.embedUrl = embedUrl;
  }
}

/**
 * Class that represents a report config list response
 */
export class ReportConfigList extends RestItemList<ReportConfig> {
  /**
   * Report list
   */
  @autoserializeAsArray(() => ReportConfig) items: ReportConfig[];

  /**
   * Number of entries in list
   */
  @autoserializeAs(() => Number) total: number;

  constructor(items: ReportConfig[] = [], total = 0) {
    super();
    this.items = items;
    this.total = total;
  }
}
